import { TranslateService } from '@ngx-translate/core';

import { PopupInit } from './init-popup';
import { GlobalInfo, LanguageKeys, Severities } from './shared.model';
import { SharedService } from './shared.service';
import { supportedLangs } from '../core/app-config';
import { CapitalizeFirstPipe } from './pipes/custom-pipes.pipe';
declare var $: any;

export class BaseComponent extends PopupInit {

    public sDateFormat: string = 'mm/dd/yy';
    public hourFormat: string = '12';



    constructor(protected sharedService: SharedService, protected translate: TranslateService) {
        super();
        translate.addLangs(supportedLangs);
        // translate.setDefaultLang('en');

        // this.globalInfo().Resource = LanguageKeys[this.globalInfo().LanguageId];
        if (translate.getLangs().find(f => f == this.globalInfo().Resource))
            translate.use(this.globalInfo().Resource);
        else if (translate.getLangs().find(f => f == this.globalInfo().ResourceLanguage))
            translate.use(this.globalInfo().ResourceLanguage);
        else
            translate.use(this.globalInfo().ResourceDefault);
        this.getDateFormat();
    }
    protected globalInfo(): GlobalInfo {
        return this.sharedService.globalInfo();
    }
    private getDateFormat() {
        let culture = this.sharedService.globalInfo().Culture;
        switch (culture) {
            case 'en-US':
                this.sDateFormat = 'm/d/yy';
                break;
            case 'en-GB' || 'fr' || 'fr-FR' || 'ar-OM' || 'ar-SA':
                this.sDateFormat = 'dd/mm/yy';
                break;
            case 'en-SG':
                this.sDateFormat = 'd/m/yy';
                break;
        }
    } //getDateFormat ends

    // Start Region Layout Based  Functionalities
    public LeftPanelToggle() {
        var dtoggle = document.getElementsByClassName("layout-panel")[0];
        var icon = dtoggle.getElementsByTagName("i")[0];
        if (dtoggle.className.indexOf('leftpanel-open') >= 0) {
            dtoggle.classList.remove('leftpanel-open');
            // icon.classList.add('rotate');
            icon.classList.add('rotate-font');
        }
        else {
            dtoggle.classList.add('leftpanel-open');
            // icon.classList.remove('rotate');
            icon.classList.remove('rotate-font');
        }
    }

    // End Region Region Layout Based  Functionalities
    //Right panel open
    public RighttPanelToggle() {
        var dtoggle = document.getElementsByClassName("right-panel")[0];
        var dtoggle1 = document.getElementsByClassName("list-heading")[0];
        var icon = dtoggle.getElementsByTagName("i")[0];
        if (dtoggle.className.indexOf('rightpanel-open') >= 0) {
            dtoggle.classList.remove('rightpanel-open');
            icon.classList.remove('rotate');
            icon.classList.remove('rotate-font');
            dtoggle1.classList.remove('hide');
        }
        else {
            dtoggle.classList.add('rightpanel-open');
            icon.classList.add('rotate');
            icon.classList.add('rotate-font');
            dtoggle1.classList.add('hide');
        }
    }
    notesevents() {
        setTimeout(function () {
            var inspanel = document.getElementsByClassName('inst-panel');
            for (let i = 0; i < inspanel.length; i++) {
                var instnote = inspanel[i].clientWidth;
                var ds: any = inspanel[i].getElementsByClassName("noteinst-ovfcont")[0];
                ds.style.width = (instnote - 220)
            }
        });
    }
    public togglenavbar() {
        this.notesevents();
        var togglenavbar = document.getElementsByClassName('togglenavbar')[0].getElementsByTagName('a')[0].getElementsByTagName('i')[0];
        var tpnav = document.getElementById("top-nav");
        var laypanel = document.getElementsByClassName('layout-panel')[0];
        var resnoti = document.getElementsByClassName('res-notification')[0];
        var contwarp = document.getElementsByClassName('content-wrap')[0];

        var breadcrumbhead = document.getElementsByClassName('breadcrumb-heading')[0];
        var navnoti = document.getElementsByClassName('nav-notification')[0];
        var wmenu: any = document.getElementsByClassName('wrap-menu')[0];
        var slevel: any = wmenu.getElementsByClassName('second-level')[0];
        var sidemenu = document.getElementsByClassName("wrap-menu")[0].clientWidth;
        var bchead = document.getElementsByClassName("breadcrumb-heading")[0].clientHeight;
        var tio: any = document.getElementById('main-container').getElementsByClassName('layout-panel')[0];

        if (tpnav.className.indexOf('hide-top') >= 0) {
            //togglenavbar.classList.remove('rotate');
            togglenavbar.classList.remove('rotate-font');
            tpnav.classList.remove('hide-top');
            laypanel.classList.remove('no-headermenu');
            resnoti.classList.remove('hide-top');
            contwarp.classList.remove('zero-mar-pad');
            contwarp.classList.remove('fp_breadcrum_open');
            breadcrumbhead.classList.remove('brdcrb-fullwid');
            navnoti.classList.remove('res-top-navnote');
            wmenu.style.left = 0;
            slevel.style.left = sidemenu + "px";
            setTimeout(function () {
                tio.style.top = bchead;
            });
        }
        else {
            // togglenavbar.classList.add('rotate');
            togglenavbar.classList.add('rotate-font');
            tpnav.classList.add('hide-top');
            laypanel.classList.add('no-headermenu');
            resnoti.classList.add('hide-top');
            contwarp.classList.add('zero-mar-pad');
            breadcrumbhead.classList.add('brdcrb-fullwid');
            contwarp.classList.add('fp_breadcrum_open');
            navnoti.classList.add('res-top-navnote');
            wmenu.style.left = -sidemenu + "px";
            slevel.style.left = (-sidemenu - 50) + "px";
            setTimeout(function () {
                tio.style.top = bchead;
            });
        }
    }
    GoogleMapScript() {
        debugger

        if (this.globalInfo().MapId == "2") {
            this.sharedService.getMapKey(this.globalInfo().MapKey).subscribe(res => {
                if (res.Message.Severity == Severities.success) {
                    var doc = document.getElementById("googlemapid");
                    // var key = "AIzaSyCMETFywwODShFN4IpVMlMfUdg921KbgZk";
                    if (typeof doc == "undefined" || doc == null) {
                        var x = document.createElement('script');
                        x.title = "GoogleMapScript";
                        x.async = true;
                        x.hidden = true;
                        x.id = "googlemapid";
                        x.defer = true;
                        var KeyValue = res.Data;
                        //sensor=false&libraries=drawing
                        x.src = 'https://maps.googleapis.com/maps/api/js?key=' + KeyValue + '&&libraries=drawing,geometry,places&sensor=false';
                        //   x.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&&libraries=places&sensor=false';
                        document.getElementById("hiddenscript").appendChild(x);
                    }
                }
                else {
                    this.sharedService.notification.emit({
                        severity: Severities[3],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                        detail: this.translate.instant("INVALIDKEY")
                    });
                }
            });
        }
    }
    //Right panel open

    protected leftPanelTitle() {
        $('.left-panel .panel-title').each(function () {
            var panelTitlewid = $(this).width();
            var panelIcon = $(this).find('.pull-right').width();
            var tWid = panelTitlewid - panelIcon;
            var panelisvisible = $(this).find('.pull-right');
            if ($(panelisvisible).length) {
                $(this).find('.title-overflow').css('width', tWid - 19);
            } else {
                $(this).find('.title-overflow').css('width', tWid - 24);
            }
        });
    }

    showEmailJob(jobId: number, woId: number, techId: number, pageid: number) {
        //pageid - 1 dispatcher board, 2 Tech jobs
        let obj = { jobId: jobId, woId: woId, techId: techId, pageid: pageid };
        this.sharedService.emailJob.emit({ key: obj, value: true });
    }

    closeEmailPopup() {
        this.sharedService.emailJob.emit({ key: 0, value: false });
    }


    showQuoteEmailJob(jobId: number, woId: number, techId: number, pageid: number) {
        //pageid - 1 dispatcher board, 2 Tech jobs
        let obj = { jobId: jobId, woId: woId, techId: techId, pageid: pageid };
        this.sharedService.quoteemailJob.emit({ key: obj, value: true });
    }

    closeQuoteEmailPopup() {
        this.sharedService.quoteemailJob.emit({ key: 0, value: false });
    }


}